/**
 * Created by Michael Stanaland on 3/11/2020.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    description: PropTypes.string,
    shouldUseTemplate: PropTypes.bool
};

const defaultProps = {
    title: "The Hub",
    url: "https://manage.recreation.gov",
    shouldUseTemplate: true,
    description: "The Hub is an internal tool for controlling Recreation.gov content and settings."
};

const DEFAULT_TEMPLATE = 'The Hub: %s';

export default class HelmetWrapper extends React.PureComponent {
    render() {
        const { shouldUseTemplate } = this.props;
        const template = shouldUseTemplate ? DEFAULT_TEMPLATE : null;

        return (
            <Helmet titleTemplate={template}>
                <title>{this.props.title}</title>
                <meta name="description" content={this.props.description} />

                <meta property="og:title" content={this.props.title} />
                <meta property="og:url" content={this.props.url} />
                <meta property="og:description" content={this.props.description} />
            </Helmet>
        );
    }
}

HelmetWrapper.propTypes = propTypes;
HelmetWrapper.defaultProps = defaultProps;
